export default require("../templates/Register").default
